// Dados das seções de soluções (textos, badges e imagens)

// Imagens principais das soluções
import pulmoscanMainImg from '../assets/pulmoscan/pulmoscan-img.png';
import pulmogameMainImg from '../assets/pulmoscan/pulmogame-img.png';
import saasMainImg from '../assets/pulmoscan/saas-img.png';
import pulmoflowAppImg from '../assets/pulmoflow/pulmoflow_app.png';
import saasPulmoflowImg from '../assets/pulmoflow/saas_pulmoflow.png';

export const pulmoscanData = {
  title: 'PulmoScan',
  subtitle: 'Gestão, Avaliação e Engajamento em um só lugar',
  paragraphs: [
    'O PulmoScan é o aplicativo central do ecossistema BTOne, usado pelo profissional para gerenciamento e avaliação de reabilitação respiratória (PImáx e PEmáx). Integra cadastro de pacientes e fisioterapeutas, avaliações, relatórios inteligentes com IA e o módulo gamificado PulmoGame para engajamento.',
    'Todos os dados ficam armazenados com total segurança na nuvem, garantindo acessibilidade e proteção para suas informações.'
  ],
  bullets: [
    '<strong>Gerenciamento:</strong> Adicione pacientes e vincule fisioterapeutas de forma simples e intuitiva, organizando todo o fluxo de trabalho em um só lugar.',
    '<strong>Avaliações e Treinamentos:</strong> Realize avaliações de PImáx e PEmáx, utilizando equações de normalização. Vincule cada avaliação a um paciente e fisioterapeuta para um acompanhamento detalhado.',
    '<strong>Relatórios Inteligentes e Laudos com IA:</strong> Visualize e gere relatórios completos da avaliação ou treinamento respiratório. Além disso, configure a API do usuário para gerar laudos detalhados e prontos com a ajuda de inteligência artificial.'
  ],
  badges: [
    { icon: '☁️', text: 'Dados na Nuvem' },
    { icon: '🤖', text: 'Relatórios Inteligentes' },
    { icon: '🎮', text: 'PulmoGame Integrado' }
  ],
  singleImage: pulmoscanMainImg,
  images: []
};

export const pulmogameData = {
  title: 'PulmoGame',
  subtitle: 'Jogos Respiratórios Interativos',
  paragraphs: [
    'Transforme o treinamento respiratório em uma experiência divertida e envolvente! O PulmoGame é um sistema que utiliza a gamificação para tornar a reabilitação pulmonar mais lúdica e eficaz para todas as idades.',
    'No menu do PulmoGame, personalize a experiência ajustando nível de dificuldade e duração de cada sessão.'
  ],
  bullets: [
    '<strong>PulmoPlane:</strong> Controle um avião e colete moedas desviando de obstáculos via controle respiratório.',
    '<strong>PulmoRocket:</strong> Suba o foguete com a força do sopro, fortalecendo músculos expiratórios.',
    '<strong>PulmoSpider:</strong> Oposto ao PulmoRocket, focado em treinamento inspiratório.'
  ],
  badges: [
    { icon: '🎮', text: 'Minigames' },
    { icon: '🏆', text: 'Ranking' },
    { icon: '👨‍👩‍👦‍👦', text: 'Para todas as idades' }
  ],
  singleImage: pulmogameMainImg,
  images: []
};

export const saasData = {
  title: 'Portal de Gerenciamento PulmoScan',
  subtitle: 'Administração centralizada para clínicas e profissionais',
  paragraphs: [
    'Plataforma web para gerenciamento completo do ecossistema BTOne: cadastros, sessões e relatórios. Ideal para clínicas, redes de saúde e profissionais de saúde.'
  ],
  bullets: [

    '<strong>Gestão de Clínicas e Fisioterapeutas:</strong> Cadastro, edição e acompanhamento.',
    '<strong>Pacientes e Sessões:</strong> Histórico unificado e acompanhamento de avaliações/treinamentos.',
    '<strong>Relatórios:</strong> Transparência com registros.',
    '<strong>Integração com PulmoScan:</strong> Sincronização de dados e relatórios.'
  ],
  badges: [
    { icon: '🖥️', text: 'SaaS' },
    { icon: '🏥', text: 'Multi-clínicas' },
    { icon: '🔐', text: 'Acesso Seguro' }
  ],
  singleImage: saasMainImg,
  images: []
};

export const pulmoflowData = {
  title: 'PulmoFlow',
  subtitle: 'Pico de Fluxo e Monitoramento',
  inDevelopment: true,
  paragraphs: [
    'O PulmoFlow é o aplicativo do ecossistema BTTwo, voltado ao paciente para coleta de pico de fluxo e monitoramento. O paciente usa o app e o equipamento BTTwo para coletar amostras, responder questionários ACT e CAT e enviar dados aos médicos.',
    'Todos os dados são enviados ao sistema web, onde o profissional analisa o histórico e acompanha a evolução do paciente.'
  ],
  bullets: [
    '<strong>Equipamento BTTwo:</strong> Medidor de pico de fluxo com conectividade Bluetooth.',
    '<strong>Questionários ACT e CAT:</strong> O paciente responde diretamente no aplicativo.',
    '<strong>Envio de Amostras:</strong> Dados enviados aos profissionais de saúde para análise no sistema web.'
  ],
  badges: [
    { icon: '🌬️', text: 'Pico de Fluxo' },
    { icon: '📋', text: 'ACT/CAT' },
    { icon: '👤', text: 'Foco no Paciente' }
  ],
  singleImage: pulmoflowAppImg,
  images: []
};

export const saasPulmoflowData = {
  title: 'Portal de Gerenciamento PulmoFlow',
  subtitle: 'Administração centralizada para acompanhamento de pacientes',
  inDevelopment: true,
  paragraphs: [
    'Plataforma web para gerenciamento completo do ecossistema PulmoFlow: visualização de amostras de pico de fluxo, questionários ACT/CAT respondidos pelos pacientes e histórico clínico. O profissional recebe e analisa todos os dados enviados pelo aplicativo.'
  ],
  bullets: [
    '<strong>Visualização de Amostras:</strong> Pico de fluxo e dados coletados pelo paciente.',
    '<strong>Questionários ACT/CAT:</strong> Acesso às respostas e evolução do controle da asma.',
    '<strong>Histórico e Acompanhamento:</strong> Análise unificada para decisões clínicas.',
    '<strong>Integração com PulmoFlow:</strong> Sincronização de dados do aplicativo.'
  ],
  badges: [
    { icon: '🖥️', text: 'SaaS' },
    { icon: '📊', text: 'Análise de Dados' },
    { icon: '🔐', text: 'Acesso Seguro' }
  ],
  singleImage: saasPulmoflowImg,
  images: []
};


